import { combineReducers } from 'redux'

import systemReducer from './system/reducer'

export const reducer = combineReducers({
  system: systemReducer,
})
